import type { Locale } from '../i18n/types';

export interface SiteUiMessages {
    home: string;
    language: string;
    openTool: string;
    theme: { label: string; system: string; light: string; dark: string; next: string };
    featureHeading: string;
    notFoundTool: string;
    legalNavigation: string;
    parentSite: string;
    updatedAt: string;
}

export const siteUiMessages: Readonly<Record<Locale, SiteUiMessages>> = {
    en: {
        home: 'Home',
        language: 'Language',
        openTool: 'Open tool',
        theme: {
            label: 'Color theme',
            system: 'System',
            light: 'Light',
            dark: 'Dark',
            next: 'Switch to %{theme}',
        },
        featureHeading: 'One private workspace, the complete model surface.',
        notFoundTool: 'Open the tool instead',
        legalNavigation: 'Legal',
        parentSite: 'sunuyoruz.biz',
        updatedAt: 'Last updated: %{date}',
    },
    tr: {
        home: 'Ana sayfa',
        language: 'Dil',
        openTool: 'Aracı aç',
        theme: {
            label: 'Renk teması',
            system: 'Sistem',
            light: 'Açık',
            dark: 'Koyu',
            next: '%{theme} temasına geç',
        },
        featureHeading: 'Tek bir özel çalışma alanında eksiksiz model yüzeyi.',
        notFoundTool: 'Bunun yerine aracı aç',
        legalNavigation: 'Yasal',
        parentSite: 'sunuyoruz.biz',
        updatedAt: 'Son güncelleme: %{date}',
    },
};

export function interpolateSiteMessage(
    message: string,
    values: Readonly<Record<string, string | number>>
): string {
    return message.replace(/%\{([^}]+)\}/g, (match, parameter: string) => {
        const value = values[parameter];
        return value === undefined ? match : String(value);
    });
}
